import { deleteField } from "firebase/firestore"
import _ from 'lodash'
import { removeFromObject } from "../../../../../global/common/sorting"
import { createRefPath_event } from "../../../../../global/firestoreData/appData/appRefPaths"
import { geGCGHandicapIndex } from "../../../golfCalcs/courseHandicap"
import { fields_golferTournament } from "../GolfTournamentReducer"

export const golfFixHelpers = {
  fixFromMatches: (state) => fixFromMatches(state),
  fixGolferHandicaps: (state) => fixGolferHandicaps(state),
  fixGolfers_tournament: (state) => fixGolfers_tournament(state),
  fixGolfers: (golfers, golfers_event, golfCourses) => fixGolfers(golfers, golfers_event, golfCourses),
  fixLineups: (lineups, golfers_event) => fixLineups(lineups, golfers_event),
  fixRounds: (rounds) => fixRounds(rounds),
  fixTeams: (teams) => fixTeams(teams),
  fixTournament: (state) => fixTournament(state),
  getGolferKey: (tournamentGolfer, golfers_event) => getGolferKey(tournamentGolfer, golfers_event),
}

const fixTournament = (state) => {

  const { pathViews, golfEvent_state } = state
  const { golfers: golfers_event, golfCourses } = golfEvent_state ?? {}

  const _callBack = (res) => {

    const { golfers, lineups, rounds, teams } = res

    const _golfers = fixGolfers(golfers, golfers_event, golfCourses)
    const _lineups = fixLineups(lineups, golfers_event)
    const _rounds = fixRounds(rounds)
    const _teams = fixTeams(teams)

    const details = {
      golfers: _golfers,
      lineups: _lineups,
      rounds: _rounds,
      teams: _teams,
    }

    const _refPathU = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'details', 'details'])

    database_fns.set_doc(_refPathU, details, true)

  }

  const _refPath = createRefPath_event(pathViews, ['_golfTournaments', 'JSbL0WiQ0XPmuC4MTb73'])
  // console.log('_refPath', _refPath)
  database_fns.get_data({ refPath: _refPath, callback: _callBack, opts: { returnFirstObject: true } })

}

const fixGolfers_tournament = (state) => {
  const backupDetails = false
  const { pathViews, _details } = state
  const { golfers } = _details ? _details : {}
  if (golfers) {
    const fixedGolfers = {}
    Object.keys(golfers).forEach((golferKey, index) => {
      const golfer = golfers[golferKey]
      const fixedGolfer = {}
      Object.keys(golfer).forEach(propKey => {
        if (fields_golferTournament.includes(propKey)) {
          fixedGolfer[propKey] = golfer[propKey]
        } else {
          fixedGolfer[propKey] = deleteField()
        }
      })
      fixedGolfers[golferKey] = fixedGolfer
    })
    const _refPathU = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'details', 'details'])
    const dataToUpdate = { golfers: fixedGolfers }
    console.log('_refPathU', _refPathU)
    console.log('dataToUpdate', dataToUpdate)
    // database_fns.set_doc(_refPathU, dataToUpdate, true)
  }
  if (_details && backupDetails) {
    const _refPathD = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'details_backup', 'details'])
    console.log('_refPathD', _refPathD)
    console.log('_details', _details)
    database_fns.set_doc(_refPathD, _details, true)
  }
}

const fixGolferHandicaps = (state) => {
  const courseKey = '2xSDTm7EZXmeRTCNhiUM'
  const courseTb = 'black'
  const { golfers, pathViews, golfTournament } = state
  const { golfCourse: golfCourseKey } = golfTournament ?? {}
  const _golfCourseKey = golfCourseKey ? golfCourseKey : courseKey
  if (golfers) {
    let _golfers = _.cloneDeep(golfers);
    Object.keys(_golfers).forEach(k => {
      const g = _golfers[k]
      const { teebox, courseHandicap, handicapIndex } = g ? g : {}
      const _ch = courseHandicap ? courseHandicap : handicapIndex
      g.courseHandicaps = { [_golfCourseKey]: _ch }
      g.courseTeeboxes = { [_golfCourseKey]: teebox ? teebox : courseTb }
      if (!courseHandicap) { g.noTrueCourseHandicap = true }
      g._itemKey = deleteField()
      g.courseHandicap = deleteField()
      g._existingKey = deleteField()
      g.key = deleteField()
      g.shortName = deleteField()
      g.teebox = deleteField()
    })
    const _refPathU = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'details', 'details'])
    const dataToUpdate = { golfers: _golfers }
    console.log('_refPathU', _refPathU)
    console.log('dataToUpdate', dataToUpdate)
    // database_fns.set_doc(_refPathU, dataToUpdate, true)
  }
}

const fixGolfers = (golfers, golfers_event, golfCourses) => {
  const _golfers = {}
  if (golfers) {
    Object.keys(golfers).forEach(k => {
      const golfer = golfers[k]
      const gk = getGolferKey(golfer, golfers_event)
      const _golfer = { ...golfer }
      _golfer.handicapIndex = golfer.handicap
      if (!_golfer.handicapIndex) {
        _golfer.handicapIndex = golfer.handicapIndex
      }
      const { courseHandicap } = geGCGHandicapIndex(_golfer, '2xSDTm7EZXmeRTCNhiUM', golfCourses, _golfer.handicapIndex, 'cranberry')
      _golfer.courseHandicap = courseHandicap
      _golfer.teamNumber = _golfer.tournamentTeams === '2' ? 2 : 1
      _golfer.teebox = ['cranberry']
      removeFromObject(_golfer, ['handicap', 'id', 'key', 'tournamentTeams', 'groupNumber', 'position'])

      _golfers[gk] = _golfer
    })
  }
  return _golfers
}

const fixLineups = (lineups, golfers_event) => {
  const _lineups = { team1: {}, team2: {} }
  if (lineups) {
    Object.keys(lineups).forEach(k => {
      const lineup = lineups[k]
      const { name, tournamentGolfers, tournamentTeams } = lineup
      let ln = _.camelCase(name)
      ln = ln.replace('Lineup', '')
      switch (tournamentTeams) {
        case '1':
          if (!_lineups.team1[ln]) { _lineups.team1[ln] = [] }
          break;
        case '2':
          if (!_lineups.team2[ln]) { _lineups.team2[ln] = [] }
          break;
        default:
        // nothing
      }
      if (tournamentGolfers) {
        Object.keys(tournamentGolfers).forEach(tgk => {
          const tournamentGolfer = tournamentGolfers[tgk]
          const tg = { ...tournamentGolfer }
          tg.golferKey = getGolferKey(tg, golfers_event)
          removeFromObject(tg, ['key', 'name'])
          switch (tournamentTeams) {
            case '1':
              _lineups.team1[ln].push(tg)
              break;
            case '2':
              _lineups.team2[ln].push(tg)
              break;
            default:
            // nothing
          }
        })
      }
    })
  }
  return _lineups
}

const fixRounds = (rounds) => {
  const _rounds = {}
  if (rounds) {
    Object.keys(rounds).forEach(k => {
      switch (k) {
        case 'alternativeShot':
        case 'alternateShot':
        case 'bestBall':
        case 'singles':
          const round = rounds[k]
          let { name, golfersPerTeam, numberOfMatches, roundNumber, startDate, startTime } = round
          if (name === 'alternativeShot') { name = 'alternateShot' }
          _rounds[name] = {
            golfCourse: '2xSDTm7EZXmeRTCNhiUM',
            golfersPerTeam,
            name: name,
            numberOfMatches,
            roundNumber,
            startDate,
            startTime,
            lineUps: {
              team1: name,
              team2: name
            }
          }
          break;
        default:
        // nothing
      }

    })
  }
  return _rounds
}

const fixTeams = (teams) => {
  const _teams = {}
  if (teams) {
    Object.keys(teams).forEach(k => {
      const team = teams[k]
      const { captain, name, teamNumber } = team
      _teams[teamNumber === 1 ? 'team1' : 'team2'] = {
        captain,
        name,
        teamNumber
      }

    })
  }
  return _teams
}

const getGolferKey = (tournamentGolfer, golfers_event) => {
  const { name, lastName, firstName } = tournamentGolfer
  let tgn = name ? name : firstName + ' ' + lastName
  let golferKey = _.findKey(golfers_event, function (g) {
    switch (tgn) {
      case 'Pat Callahan':
        tgn = 'Pat Callaghan'
        break;
      default:
      // nothing
    }
    return g.firstName + ' ' + g.lastName === tgn
  })
  if (!golferKey) {
    switch (tgn) {
      case 'Jeff Sr. Thompson':
        golferKey = 'g4GAPanII16TkoNb47gF'
        break;
      default:
      // nothing
    }
  }
  return golferKey
}

const fixFromMatches = (state) => {
  const _golfCourseKey = 'xMmeLJoluqPAqZihIHje'
  const courseTb = 'black'
  const { matches, pathViews, golfEvent_state } = state
  const { golfers } = golfEvent_state
  const _golfers = {}
  const _lineups = { team1: {}, team2: {} }
  if (matches) {
    Object.keys(matches).forEach(rk => {
      const matches_byRound = matches[rk]
      if (_.isObject(matches_byRound)) {
        const _roundMatches = _.sortBy(matches_byRound, 'matchNumber')
        _roundMatches.forEach(m => {
          if (!_lineups.team1[rk]) { _lineups.team1[rk] = [] }
          if (!_lineups.team2[rk]) { _lineups.team2[rk] = [] }
          const { team1, team2 } = m
          if (team1) {
            Object.keys(team1).forEach(gk => {
              const golfer = team1[gk]
              const _g = golfers[gk]
              const gi = parseFloat(_g.handicapIndex).toFixed(1)
              _golfers[gk] = {
                firstName: _g.firstName,
                lastName: _g.lastName,
                name: _g.firstName + ' ' + _g.lastName,
                teamNumber: 1,
                handicapIndex: _g.handicapIndex,
                tournamentHandicapIndex: _g.handicapIndex,
                noTrueCourseHandicap: true,
                courseHandicaps: { [_golfCourseKey]: gi },
                courseTeeboxes: { [_golfCourseKey]: courseTb }
              }
              _lineups.team1[rk].push({
                golferKey: gk,
                groupNumber: Math.round((golfer.position + 1) / 2),
                position: golfer.position
              })
            })
          }
          if (team2) {
            Object.keys(team2).forEach(gk => {
              const golfer = team2[gk]
              const _g = golfers[gk]
              const gi = parseFloat(_g.handicapIndex).toFixed(1)
              _golfers[gk] = {
                firstName: _g.firstName,
                lastName: _g.lastName,
                name: _g.firstName + ' ' + _g.lastName,
                teamNumber: 2,
                handicapIndex: _g.handicapIndex,
                tournamentHandicapIndex: _g.handicapIndex,
                noTrueCourseHandicap: true,
                courseHandicaps: { [_golfCourseKey]: gi },
                courseTeeboxes: { [_golfCourseKey]: courseTb }
              }
              _lineups.team2[rk].push({
                golferKey: gk,
                groupNumber: Math.round((golfer.position + 1) / 2),
                position: golfer.position
              })
            })
          }
        })
      }

    })
  }
  const _refPathU = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'details', 'details'])
  const dataToUpdate = { golfers: _golfers }
  console.log('_refPathU', _refPathU)
  console.log('dataToUpdate', dataToUpdate)
  database_fns.set_doc(_refPathU, dataToUpdate, true)
}
